import { images } from "../constants";

const home = [
    { 
        id: 1,
        image: images.home1,
        subtitle: "Welcome to Botanica",
        headingPart1: "Premium",
        spanText: "Gardening & Landscaping",
        headingPart2: "Services",
        buttonText: "Contact Us",
        buttonLink: 'contact-us'
    },
    {
        id: 2,
        image: images.home2,
        subtitle: "Welcome to Botanica",
        headingPart1: "Premium",
        spanText: "Garden Design & Installation",
        headingPart2: "Services",
        buttonText: "Contact Us",
        buttonLink: 'contact-us'
    },
    {
        id: 3,
        image: images.home3,
        subtitle: "Welcome to Botanica",
        headingPart1: "Custom",
        spanText: "Gardening & Landscaping",
        headingPart2: "Designs",
        buttonText: "Contact Us",
        buttonLink: 'contact-us'
    },
];

export default home;